const form_template = `
    <div class='row'>
        <div class='col-lg-12'>
            <amt-form-inline
                name='runner_battler.RbSegmentsForm'
                on-submit='updateCharts(model)'
                extend-model='$root.chartParams.filters'
            >
            </amt-form-inline>
        </div>
    </div>
`;
const inject_rb_form = function(state) {
    state['views']['main-filter@amt.ww2'] = {
        template: form_template,
    };
    return state;
};

export {
    inject_rb_form,
    form_template,
};
